var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseLayout', {
    attrs: {
      "displayBreadCrumbs": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('v-icon', {
          on: {
            "click": _vm.navigateBack
          }
        }, [_vm._v("mdi-arrow-left")]), _vm._v(" Hjelpeside ")];
      },
      proxy: true
    }])
  }, [[_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._v(" På denne siden finner du informasjon om brukerveiledninger til Minside og kontaktinformasjon for support. ")]), _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('h4', [_vm._v("Minside - Universum - brukerveiledninger")]), _c('ul', {
    staticClass: "list-style"
  }, [_c('li', [_c('a', {
    staticClass: "hover-underline-animation",
    attrs: {
      "href": "https://kurs.lo.no/skjemaogveiledning/",
      "target": "_blank"
    }
  }, [_vm._v("Brukerveiledning og skjemaer ")])])])]), _c('hr'), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('h4', [_c('strong', [_vm._v("Kontakt kundeservice")])]), _c('p', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v(" Henvend deg til din kompetanserådgiver/kontaktperson dersom du har spørsmål om et konkret kurs eller studie. For andre spørsmål knyttet til bruk av Minside, henvend deg til kundeservice: ")]), _c('div', [_c('h5', [_vm._v("LO Kurs og Konferanse")]), _c('ul', {
    staticClass: "list-style"
  }, [_c('li', [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("mdi-email")]), _c('a', {
    staticClass: "hover-underline-animation",
    attrs: {
      "href": "mailto:kurs@lo.no",
      "target": "_blank"
    }
  }, [_vm._v("kurs@lo.no ")])], 1), _c('li', [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("mdi-phone")]), _c('a', {
    staticClass: "hover-underline-animation",
    attrs: {
      "href": "tel:+4790275948",
      "target": "_blank"
    }
  }, [_vm._v("902 75 948 ")])], 1)])])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }